import { render, staticRenderFns } from "./CustomerBankAccount.vue?vue&type=template&id=6295389b&scoped=true&"
import script from "./CustomerBankAccount.vue?vue&type=script&lang=js&"
export * from "./CustomerBankAccount.vue?vue&type=script&lang=js&"
import style0 from "./CustomerBankAccount.vue?vue&type=style&index=0&id=6295389b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6295389b",
  null
  
)

export default component.exports